/// <amd-module name="Dashboards/Directory/components/TeamCell" />
import * as React from "react";
import { connect } from "react-redux";
import { IProjectData } from "Tfs/Platform/Page";
import { currentProject } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageData";
import { ITfsPageDataAwareState } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataContracts";
import { TeamPanelIconButton } from "TFS/TeamPanel/TeamPanelIcon/TeamPanelIcon";
import { IDirectoryArtifact } from "VSS/Features/Directory/DirectoryContracts";
import { IDirectoryRow } from "VSS/Features/Directory/DirectoryGrid";
import { Tooltip } from "VSSUI/TooltipEx";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";
import { IDashboardsDirectoryAwareState } from "../DashboardsDirectoryContracts";
import { getCanUseTeamButtonPermission } from "../redux/DashboardsDirectorySelectors";

export interface ITeamCellOwnProps<T extends IDirectoryArtifact> {
    row: IDirectoryRow<T>;
}

export interface ITeamCellMappedProps {
    project: IProjectData;
    enableTeamButton: boolean;
}

export interface ITeamCellProps<T extends IDirectoryArtifact> extends ITeamCellOwnProps<T>, ITeamCellMappedProps {}

/** 
 * Legacy code - will be removed once new Dashboard directory is moved to GA
 * Renders the owner of a dashboard as well as an icon for showing the team panel */
export class TeamCell<T extends IDirectoryArtifact> extends React.PureComponent<ITeamCellProps<T>> {
    public render(): JSX.Element {
        const {
            row: { data },
            project
        } = this.props;

        if (!data || !data.owners || data.owners.length === 0) {
            return <></>;
        }

        const content = data.owners.map(o => o.name).join(", ");

        const teamIcon = this.props.enableTeamButton ? (
            <TeamPanelIconButton projectName={project.name} projectId={project.id} teamId={data.owners[0].id} teamName={data.owners[0].name} />
        ) : (
            <VssIcon className={"team-icon"} iconName={"bowtie-users"} iconType={VssIconType.bowtie} />
        );

        return (
            <div className="directory-row-team-cell">
                {teamIcon}
                <Tooltip overflowOnly={true} text={content}>
                    <span className="team-name flex-tooltip-host">{content}</span>
                </Tooltip>
            </div>
        );
    }
}

function mapStateToProps(state: IDashboardsDirectoryAwareState & ITfsPageDataAwareState): ITeamCellMappedProps {
    return {
        project: currentProject(state)!,
        enableTeamButton: getCanUseTeamButtonPermission(state)
    };
}

export const ConnectedTeamCell = connect(mapStateToProps)(TeamCell);
